import { Button } from '@mui/material';
import { Icons } from '../../../common/icons/Icons';
import React from 'react';

type ShowrunnrAIButtonProps = {
    onClick?: () => void;
};

export default React.forwardRef<HTMLButtonElement, ShowrunnrAIButtonProps>(({ onClick = undefined, ...props }, ref) => {
    return (
        <Button
            ref={ref}
            sx={{
                background: 'linear-gradient(313deg, #0011A8 -37.99%, #04D6ED 131.4%)',
                borderRadius: 6,
                width: '28px',
                height: '28px',
                color: 'white',
                padding: 'unset',
                minWidth: '28px',
                '& .MuiButton-startIcon': { mr: 0, ml: 0 }
            }}
            startIcon={<Icons.AutoAwesome sx={{ width: '16px', height: '16px' }} />}
            onClick={onClick}
            {...props}
        />
    );
});
